import React from "react";

import { CbTemplateViewProps } from "../../../../types/cb-template-view/cb-template-view.props";

import { CbTemplateControlAdditionalDetails } from "../../../cb-template-control/components/cb-template-control-additional-details/cb-template-control-additional-details.component";
import { CbTemplateControlBrandFramework } from "../../../cb-template-control/components/cb-template-control-brand-framework/cb-template-control-brand-framework.component";
import { CbTemplateControlContent } from "../../../cb-template-control/components/cb-template-control-content/cb-template-control-content.component";
import { CbTemplateControlContext } from "../../../cb-template-control/components/cb-template-control-context/cb-template-control-context.component";
import { CbTemplateControlCustomerMessage } from "../../../cb-template-control/components/cb-template-control-customer-message/cb-template-control-customer-message.component";
import { CbTemplateControlCustomerTakeaway } from "../../../cb-template-control/components/cb-template-control-customer-takeaway/cb-template-control-customer-takeaway.component";
import { CbTemplateControlInsight } from "../../../cb-template-control/components/cb-template-control-insight/cb-template-control-insight.component";
import { CbTemplateControlLegalRequirements } from "../../../cb-template-control/components/cb-template-control-legal-requirements/cb-template-control-legal-requirements.component";
import { CbTemplateControlOpportunity } from "../../../cb-template-control/components/cb-template-control-opportunity/cb-template-control-opportunity.component";
import { CbTemplateControlStartEndDate } from "../../../cb-template-control/components/cb-template-control-start-end-date/cb-template-control-start-end-date.component";
import { CbTemplateControlTonality } from "../../../cb-template-control/components/cb-template-control-tonality/cb-template-control-tonality.component";
import { CbTemplateLayout } from "../../../cb-template-layout/components/cb-template-layout/cb-template-layout.component";
import { CbTemplateLayoutLeft } from "../../../cb-template-layout/components/cb-template-layout-left/cb-template-layout-left.component";
import { createCbTemplateControlProps } from "../../../../types/cb-template-control-props/cb-template-control-props.functions";

import { CbTemplateStandardRightSection } from "../cb-template-standard-right-section/cb-template-standard-right-section.component";

export const CbTemplateBrand = (props: CbTemplateViewProps) => {
  const controlProps = createCbTemplateControlProps(props);

  return (
    <CbTemplateLayout ndaData={props.ndaData}>
      <CbTemplateLayoutLeft>
        <CbTemplateControlContent {...controlProps} />
        <CbTemplateControlStartEndDate {...controlProps} />
        <CbTemplateControlInsight {...controlProps} />
        <CbTemplateControlContext {...controlProps} />
        <CbTemplateControlOpportunity {...controlProps} />
        <CbTemplateControlCustomerTakeaway {...controlProps} />
        <CbTemplateControlCustomerMessage {...controlProps} />
        <CbTemplateControlBrandFramework {...controlProps} />
        <CbTemplateControlTonality {...controlProps} />
        <CbTemplateControlAdditionalDetails {...controlProps} />
        <CbTemplateControlLegalRequirements {...controlProps} />
      </CbTemplateLayoutLeft>

      <CbTemplateStandardRightSection {...props} />
    </CbTemplateLayout>
  );
};
